import { atomWithReset } from "jotai/utils";

export const displayGenerateBookingInfoAtom = atomWithReset(false);
displayGenerateBookingInfoAtom.debugLabel = "Display Booking Info Modal";
